<template>
  <v-row justify="center">
    <v-dialog v-model="authCodeDialog" scrollable max-width="450px">
      <v-card>
        <v-card-title>{{ serial.serial_number }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 500px;" class="pb-7">
          <p class="font-weight-bold mt-7 body-2 black--text mb-2">
            매칭된 상품 정보
          </p>
          <p class="mb-0 font-weight-bold caption text-truncate">상품명 : {{ serial.product_name }}</p>
          <p class="mb-0 font-weight-bold caption text-truncate">품목명 : {{ serial.variant_name }}</p>
          <p v-if="mallType !== 'imweb'" class="mb-0 font-weight-bold caption text-truncate">상품코드 : {{ serial.product_code }}</p>
          <p v-if="mallType !== 'imweb'" class="mb-0 font-weight-bold caption text-truncate">품목코드 : {{ serial.variant_code }}</p>
          <p v-if="mallType === 'imweb'" class="mb-0 font-weight-bold caption text-truncate">상품번호 : {{ serial.product_no }}</p>
          <p v-if="mallType === 'imweb'" class="mb-0 font-weight-bold caption text-truncate">
            자체상품코드 : {{ serial.custom_product_code }}
          </p>
          <template v-for="(history, key) in histories">
            <div v-bind:key="key">
              <p class="mb-0 font-weight-bold body-2 mt-9 black--text">
                {{ history.title }}
              </p>
              <div v-if="history.detail === 'nofitication'">
                <p class="mb-0 caption text-truncate mt-1">
                  <font class="black--text">발송타입</font>
                  <font>
                    <span>&nbsp;-&nbsp;{{ history.sendTitle }}</span>
                  </font>
                </p>
                <p class="mb-0 caption text-truncate mt-1">
                  <font class="black--text">발송일시</font>
                  <font>
                    <span>&nbsp;-&nbsp;{{ history.changed_at }}</span>
                    ({{ history.updated_by }})
                  </font>
                </p>
                <p class="mb-0 caption text-truncate mt-1">
                  <font class="black--text">주문번호</font>
                  <font>
                    &nbsp;-&nbsp;<a :href="moveOrder(history.orderId)" target="_blank">{{ history.orderId }}</a>
                  </font>
                </p>
                <p v-if="history.phone" class="mb-0 caption text-truncate mt-1">
                  <font class="black--text">핸드폰번호</font>
                  <font>
                    <span>&nbsp;-&nbsp;{{ history.phone }}</span>
                  </font>
                </p>
                <p v-if="history.email" class="mb-0 caption text-truncate mt-1">
                  <font class="black--text">이메일</font>
                  <font>
                    <span>&nbsp;-&nbsp;{{ history.email }}</span>
                  </font>
                </p>
              </div>
              <p v-else class="mb-0 caption text-truncate mt-1">
                <font class="black--text">{{ history.detail }}</font>
                <font>
                  <span v-if="history.detail !== history.changed_at">&nbsp;-&nbsp;{{ history.changed_at }}</span>
                  ({{ history.updated_by }})
                </font>
              </p>
            </div>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="authCodeDialog = false">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import Filters from "@/libs/authservice/filters.js";

export default {
  data() {
    return {
      authCodeDialog: false,
      serial: {
        product_name: "",
        variant_name: "",
        product_code: "",
        variant_code: "",
      },
      histories: null,
    };
  },
  computed: {
    mallType() {
      return this.$store.state.mallType;
    },
  },
  mixins: [CommonMixin],
  methods: {
    authCodeClick: async function(data) {
      if (!data.serial_number) {
        this.authCodeDialog = false;
        return false;
      }
      try {
        let res = await M.api(M.entry("/serials/history", encodeURIComponent(data.serial_number)));

        res.serial.product_name = res.serial.product_name.replace(/<\/?[^>]+(>|$)/g, "");
        this.serial = res.serial;

        // appCode가 cert_digital인 경우 특정 title 필터링
        let filteredHistories = res.histories;
        if (this.$store.state.appCode === "cert_digital") {
          filteredHistories = res.histories.filter((history) => history.title !== "보증 기간 생성" && history.title !== "보증 기간 변경");
        }

        this.histories = filteredHistories;
        if (res.notificationHistories) {
          this.histories = this.histories.concat(this.convertNotificationHistories(res.notificationHistories));
          this.histories.sort((a, b) => new Date(a.changed_at) - new Date(b.changed_at));
        }
        console.log(this.histories);
        this.authCodeDialog = true;
      } catch (e) {
        this.authCodeDialog = false;
      }
    },
    convertNotificationHistories: function(data) {
      let histories = [];
      data.forEach((history) => {
        history.title =
          this.$store.state.appCode === "cert_digital" ? history.eventTitle : Filters.msgTypeText(history.msg_type).replace("<br/>", " ");
        history.detail = "nofitication";
        history.sendTitle = Filters.sendTypeText(history.notificationType).replace(/\(.*?\)/g, "");
        history.changed_at = history.sentAt;
        history.orderId = history.orderId.substring(0, 16);
        history.updated_by = "system";
        histories.push(history);
      });
      return histories;
    },
    moveOrder: function(orderId) {
      return `https://${this.$store.state.mallId}.cafe24.com/admin/php/shop${this.$store.state.shopNo}/s_new/order_detail.php?order_id=${orderId}`;
    },
  },
};
</script>
